import { LocationService as BaseLocationService } from '../../core';
export class LocationService extends BaseLocationService {
  constructor(location) {
    super(location);
    this.location = location;
  }
  set() {
    throw new Error('UI.Router navigation is not supported inside Viewer client');
  }
}
//# sourceMappingURL=LocationService.js.map